export default __webpack_public_path__ + "static/customer2-e753b02bdd71c38cf0349147d9b0ed71.png";